// A polar bear, modelled facing +X: a long heavy cream body, a low-slung neck and
// head with a dark nose. Ported 1:1 from age-of-mcp's classic polar-bear.ts,
// restoring its leg loop + body/head/snout/ear composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.075, 0.045], [0.075, -0.045], [-0.075, 0.045], [-0.075, -0.045]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.016, 0.015, 0.1, 5),
      color: "#dfe2e0", position: [x!, 0.05, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#f2f4f2",
      position: [0, 0.1, 0], scale: [1.9, 1, 1.05] },                // long body
    { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#f6f8f6",
      position: [0.13, 0.09, 0], scale: [1.2, 1, 1] },               // head (low)
    { geometry: new THREE.ConeGeometry(0.018, 0.04, 5), color: "#e8eae8",
      position: [0.17, 0.082, 0], rotation: [0, 0, -Math.PI / 2] },    // snout
    { geometry: new THREE.IcosahedronGeometry(0.008, 0), color: "#16140f",
      position: [0.19, 0.082, 0] },                                  // nose
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#e0e2e0",
      position: [0.12, 0.128, 0.026] },                             // ear
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#e0e2e0",
      position: [0.12, 0.128, -0.026] },
  );
  return parts;
}

export const polarBear = defineModel({
  id: "polar-bear",
  scale: 2.88, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Polar bear",
  tags: ["creature","polar","bear","low-poly","age-of-mcp","classic"],
  summary: "Low-poly polar bear.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.18,
  parts: () => partsFor(),
  animations: [],
});
